<script>
import * as XLSX from 'xlsx'

import Title from "@/components/admin/common/TitleArea.vue"
import SpecTypeForm from "@/components/fulfillment/SpecTypeForm.vue"
import PageGuideDialog from "@/components/admin/fulfillment/guide/PageGuideDialog.vue"
import MasterSkuRegisterGuide from "@/components/admin/fulfillment/guide/MasterSkuRegisterGuide.vue"

const SPEC_TYPE_OPTIONS = [
  { label: 'APPAREL_SIZE', value: 'APPAREL_SIZE' },
  { label: 'PRODUCT_OPTION', value: 'PRODUCT_OPTION' },
  { label: 'PACK_COUNT', value: 'PACK_COUNT' },
]

const EXCEL_COLUMNS = [
  { key: 'display_name', label: '상품명' },
  { key: 'brand_name', label: '브랜드' },
  { key: 'category_name', label: '카테고리' },
  { key: 'hs_code', label: 'HS CODE' },
  { key: 'barcode', label: '바코드번호' },
  { key: 'spec_type', label: '규격 타입' },
  { key: 'weight_kg', label: '중량(kg)' },
  { key: 'volume_cbm', label: '부피(cbm)' },
  { key: 'length_cm', label: '가로(cm)' },
  { key: 'width_cm', label: '세로(cm)' },
  { key: 'height_cm', label: '높이(cm)' },
  { key: 'apparel_size', label: '의류사이즈' },
  { key: 'model_code', label: '모델코드' },
  { key: 'color', label: '색상' },
  { key: 'size', label: '사이즈' },
  { key: 'pack_unit_type_code', label: '입수 코드' },
  { key: 'pack_count', label: '입수량' },
  { key: 'pack_uom', label: '입수 단위' },
  { key: 'is_active', label: '활성 여부' },
]

export default {
  name: 'AdminMasterSkuRegister',
  components: {
    Title,
    SpecTypeForm,
    PageGuideDialog,
    MasterSkuRegisterGuide,
  },
  data() {
    return {
      description: {
        title: '신규 등록'
      },
      activeTab: 'single',
      masterDataLoading: false,
      singleSaving: false,
      importLoading: false,
      importCommitting: false,
      guideDialog: false,
      brands: [],
      categories: [],
      packUnitTypes: [],
      partners: [],
      file: null,
      importRows: [],
      importSummary: {
        total: 0,
        valid: 0,
        invalid: 0,
      },
      singleForm: this.createEmptySingleForm(),
    }
  },
  computed: {
    specTypeOptions() {
      return SPEC_TYPE_OPTIONS
    },
    hasImportRows() {
      return this.importRows.length > 0
    },
    hasImportErrors() {
      return this.importRows.some((row) => Array.isArray(row.errors) && row.errors.length > 0)
    },
    partnerOptions() {
      return this.partners
        .filter((item) => Number(item?.has_fulfillment_contract) === 1)
        .map((item) => ({
          label: item.partner_name,
          value: item.id,
        }))
    },
  },
  methods: {
    openGuide() {
      this.guideDialog = true
    },
    createEmptySingleForm() {
      return {
        master_sku_code: '',
        display_name: '',
        barcode: '',
        brand_id: '',
        category_id: '',
        hs_code: '',
        spec_type: 'PRODUCT_OPTION',
        spec_detail: {
          apparel_size: '',
          model_code: '',
          color: '',
          size: '',
          pack_unit_type_code: '',
          pack_count: '',
          pack_uom: 'ea',
        },
        weight_kg: '',
        volume_cbm: '',
        length_cm: '',
        width_cm: '',
        height_cm: '',
        is_active: true,
        partner_id: '',
        partner_sku_code: '',
      }
    },
    notify(message, type = 'negative') {
      if (this.$q?.notify) {
        this.$q.notify({ message, type })
        return
      }
      alert(message)
    },
    applyRouteContext() {
      const routeTitle = String(this.$route?.meta?.title || '').replace(/^Aone 관리자 \|\s*/, '')
      if (routeTitle) {
        this.description.title = routeTitle
      }
    },
    normalizeSpecDetailForApi(specType, specDetail = {}) {
      const type = String(specType || '').toUpperCase()
      if (type === 'APPAREL_SIZE') {
        return {
          apparel_size: specDetail.apparel_size || '',
        }
      }
      if (type === 'PRODUCT_OPTION') {
        return {
          model_code: specDetail.model_code || '',
          color: specDetail.color || '',
          size: specDetail.size || specDetail.size_value || '',
        }
      }
      if (type === 'PACK_COUNT') {
        return {
          pack_unit_type_code: specDetail.pack_unit_type_code || '',
          pack_count: specDetail.pack_count || '',
          pack_uom: specDetail.pack_uom || 'ea',
        }
      }
      return {}
    },
    normalizeSpecDetailForUi(specType, specDetail = {}) {
      const type = String(specType || '').toUpperCase()
      if (type === 'APPAREL_SIZE') {
        return {
          apparel_size: specDetail.apparel_size ?? specDetail.size ?? '',
        }
      }
      if (type === 'PRODUCT_OPTION') {
        return {
          model_code: specDetail.model_code ?? specDetail.model ?? '',
          color: specDetail.color ?? '',
          size: specDetail.size ?? specDetail.size_value ?? '',
        }
      }
      if (type === 'PACK_COUNT') {
        return {
          pack_unit_type_code: specDetail.pack_unit_type_code ?? specDetail.unit ?? '',
          pack_count: specDetail.pack_count ?? specDetail.count ?? '',
          pack_uom: specDetail.pack_uom ?? 'ea',
        }
      }
      return {}
    },
    applyPreviewPayload(payload = {}) {
      const rows = Array.isArray(payload.rows) ? payload.rows : []
      this.importRows = rows.map((row) => ({
        ...row,
        spec_detail: this.normalizeSpecDetailForUi(row.spec_type, row.spec_detail || {}),
      }))
      this.importSummary = payload.summary || { total: 0, valid: 0, invalid: 0 }
    },
    refreshImportSummary() {
      this.importSummary = {
        total: this.importRows.length,
        valid: this.importRows.filter((row) => !(row.errors || []).length).length,
        invalid: this.importRows.filter((row) => (row.errors || []).length).length,
      }
    },
    async loadMasterData() {
      this.masterDataLoading = true
      const brandConfig = { method: 'GET', url: '/api/fulfillment/brands', name: '[ Fulfillment / 브랜드 목록 ]' }
      const categoryConfig = { method: 'GET', url: '/api/fulfillment/categories', name: '[ Fulfillment / 카테고리 목록 ]' }
      const packUnitConfig = { method: 'GET', url: '/api/fulfillment/pack-unit-types', name: '[ Fulfillment / 패키지 단위 목록 ]' }

      await this.$http(brandConfig).then((res) => { this.brands = res.data?.data || [] }).catch(() => { this.brands = [] })
      await this.$http(categoryConfig).then((res) => { this.categories = res.data?.data || [] }).catch(() => { this.categories = [] })
      await this.$http(packUnitConfig).then((res) => { this.packUnitTypes = res.data?.data || [] }).catch(() => { this.packUnitTypes = [] })

      this.masterDataLoading = false
    },
    async loadPartners() {
      const config = {
        method: 'POST',
        url: '/api/partner/getPartnerList',
        name: '[ Fulfillment / 파트너 목록 ]'
      }
      await this.$http(config)
        .then((res) => {
          this.partners = Array.isArray(res.data) ? res.data : []
        })
        .catch(() => {
          this.partners = []
        })
    },
    sanitizeBarcode(value) {
      this.singleForm.barcode = String(value || '').replace(/\D+/g, '').slice(0, 64)
    },
    normalizeCodePart(value, fallback) {
      const normalized = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3)
      if (normalized.length >= 3) return normalized
      if (normalized.length > 0) return normalized.padEnd(3, 'X')
      return fallback
    },
    getSelectedLabel(options, value, valueKey = 'value', labelKey = 'label') {
      const found = options.find((item) => String(item?.[valueKey]) === String(value))
      return found?.[labelKey] || ''
    },
    buildMasterSkuCodeFromForm() {
      const barcode = String(this.singleForm.barcode || '').trim()
      if (!barcode) return ''
      const brandName = this.getSelectedLabel(this.brands, this.singleForm.brand_id, 'brand_id', 'name')
      const categoryName = this.getSelectedLabel(this.categories, this.singleForm.category_id, 'category_id', 'name')
      const brandCode = this.normalizeCodePart(brandName, `B${String(this.singleForm.brand_id || 0).padStart(2, '0').slice(-2)}`)
      const categoryCode = this.normalizeCodePart(categoryName, `C${String(this.singleForm.category_id || 0).padStart(2, '0').slice(-2)}`)
      const suffix = barcode.padStart(6, '0').slice(-6)
      return `MSKU-${brandCode}-${categoryCode}-${suffix}`
    },
    generateMasterSkuCodeFromBarcode() {
      const generated = this.buildMasterSkuCodeFromForm()
      if (generated) {
        this.singleForm.master_sku_code = generated
      }
    },
    async saveSingle() {
      const normalizedSpecDetail = this.normalizeSpecDetailForApi(this.singleForm.spec_type, this.singleForm.spec_detail)
      const spec_key = this.$makeSpecKey(this.singleForm.spec_type, normalizedSpecDetail)
      if (!spec_key) {
        this.notify('규격 정보를 확인하세요.')
        return
      }
      const hasPartnerInput = Boolean(this.singleForm.partner_id || this.singleForm.partner_sku_code)
      if (hasPartnerInput && (!this.singleForm.partner_id || !String(this.singleForm.partner_sku_code || '').trim())) {
        this.notify('파트너 연결 정보는 파트너와 파트너 SKU를 함께 입력해야 합니다.')
        return
      }

      this.singleSaving = true
      const config = {
        method: 'POST',
        url: '/api/fulfillment/admin/master-skus',
        data: {
          master_sku_code: String(this.singleForm.master_sku_code || '').trim(),
          display_name: this.singleForm.display_name,
          barcode: this.singleForm.barcode || null,
          brand_id: this.singleForm.brand_id,
          category_id: this.singleForm.category_id,
          hs_code: this.singleForm.hs_code,
          spec_type: this.singleForm.spec_type,
          spec_key,
          spec_detail: normalizedSpecDetail,
          weight_kg: this.singleForm.weight_kg,
          volume_cbm: this.singleForm.volume_cbm,
          length_cm: this.singleForm.length_cm,
          width_cm: this.singleForm.width_cm,
          height_cm: this.singleForm.height_cm,
          is_active: this.singleForm.is_active,
          partner_id: this.singleForm.partner_id || null,
          partner_sku_code: String(this.singleForm.partner_sku_code || '').trim(),
        },
        name: '[ Fulfillment / 관리자 상품 단건 등록 ]'
      }

      await this.$http(config)
        .then((res) => {
          const createdId = res.data?.data?.master_sku_id
          this.notify('상품이 등록되었습니다.', 'positive')
          this.singleForm = this.createEmptySingleForm()
          if (createdId) {
            this.$router.push(`/admin/fulfillment/master-skus/${createdId}`)
          }
        })
        .catch((error) => {
          this.notify(error?.response?.data?.message || '상품 등록에 실패했습니다.')
        })
      this.singleSaving = false
    },
    downloadTemplate() {
      const sheetData = [
        EXCEL_COLUMNS.map((column) => column.label),
        ['샘플 UGG OB362', 'EVER SHOES', 'UGG', '640520', '9341517118378', 'PRODUCT_OPTION', '1', '0.004', '30', '20', '10', '', 'OB362', 'Chestnut', 'L5', '', '', '', 'Y'],
        ['샘플 의류 사이즈 M', 'NIKE', 'APPAREL', '123460', '880000000005', 'APPAREL_SIZE', '0.3', '0.001', '30', '20', '2', 'M', '', '', '', '', '', '', 'Y'],
        ['샘플 낱개 포장', 'NIKE', 'GOODS', '123462', '880000000007', 'PACK_COUNT', '0.1', '0.001', '10', '10', '5', '', '', '', '', 'ea', '12', 'ea', 'Y'],
      ]
      const ws = XLSX.utils.aoa_to_sheet(sheetData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '상품등록')
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'fulfillment_master_sku_template.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    fileSelected(fileOrFiles) {
      this.file = Array.isArray(fileOrFiles) ? fileOrFiles[0] : fileOrFiles
    },
    triggerFilePicker() {
      this.$refs.importFileInput?.click()
    },
    onNativeFileChange(event) {
      const file = event?.target?.files?.[0] || null
      this.file = file
    },
    clearSelectedFile() {
      this.file = null
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = ''
      }
    },
    async parseExcelRows(file) {
      const buffer = await file.arrayBuffer()
      const wb = XLSX.read(buffer, { type: 'array' })
      const sheetName = wb.SheetNames?.[0]
      if (!sheetName) throw new Error('엑셀 시트가 없습니다')
      const ws = wb.Sheets[sheetName]
      const raw = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' })
      const headers = (raw[0] || []).map((header) => String(header || '').trim())
      const headerMap = new Map(headers.map((header, index) => [header, index]))
      return raw.slice(1)
        .filter((row) => Array.isArray(row) && row.some((cell) => String(cell ?? '').trim() !== ''))
        .map((row, index) => {
          const mapped = { row_no: index + 2 }
          EXCEL_COLUMNS.forEach((column) => {
            const cellIndex = headerMap.get(column.label)
            mapped[column.key] = cellIndex !== undefined ? row[cellIndex] : ''
          })
          return mapped
        })
    },
    async previewImport() {
      if (!this.file) {
        this.notify('엑셀 파일을 선택하세요.')
        return
      }

      this.importLoading = true
      try {
        const rows = await this.parseExcelRows(this.file)
        const config = {
          method: 'POST',
          url: '/api/fulfillment/admin/master-skus/import/preview',
          data: { rows },
          name: '[ Fulfillment / 관리자 상품 엑셀 preview ]'
        }
        const res = await this.$http(config)
        this.applyPreviewPayload(res.data?.data || {})
      } catch (error) {
        this.notify(error?.response?.data?.message || '엑셀 미리보기에 실패했습니다.')
      } finally {
        this.importLoading = false
      }
    },
    async revalidateImportRows() {
      this.importLoading = true
      const config = {
        method: 'POST',
        url: '/api/fulfillment/admin/master-skus/import/preview',
        data: { rows: this.importRows },
        name: '[ Fulfillment / 관리자 상품 엑셀 재검증 ]'
      }
      await this.$http(config)
        .then((res) => {
          this.applyPreviewPayload(res.data?.data || {})
        })
        .catch((error) => {
          this.notify(error?.response?.data?.message || '재검증에 실패했습니다.')
        })
      this.importLoading = false
    },
    async commitImport() {
      if (!this.importRows.length) {
        this.notify('저장할 데이터가 없습니다.')
        return
      }
      if (this.hasImportErrors) {
        this.notify('오류가 있는 행을 먼저 수정하세요.')
        return
      }

      this.importCommitting = true
      const config = {
        method: 'POST',
        url: '/api/fulfillment/admin/master-skus/import/commit',
        data: { rows: this.importRows },
        name: '[ Fulfillment / 관리자 상품 엑셀 저장 ]'
      }
      await this.$http(config)
        .then((res) => {
          const count = res.data?.data?.created_count || 0
          this.notify(`${count}건의 상품이 등록되었습니다.`, 'positive')
          this.importRows = []
          this.importSummary = { total: 0, valid: 0, invalid: 0 }
          this.clearSelectedFile()
          this.$router.push('/admin/fulfillment/master-skus')
        })
        .catch((error) => {
          this.notify(error?.response?.data?.message || '엑셀 저장에 실패했습니다.')
        })
      this.importCommitting = false
    },
    removeImportRow(index) {
      this.importRows.splice(index, 1)
      this.refreshImportSummary()
    }
  },
  mounted() {
    this.applyRouteContext()
    this.loadMasterData()
    this.loadPartners()
  }
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description">
          <template #title-action>
            <q-btn
              flat
              round
              dense
              size="sm"
              color="primary"
              icon="help_outline"
              aria-label="신규 등록 사용 가이드"
              @click="openGuide"
            >
              <q-tooltip>신규 등록 사용 가이드</q-tooltip>
            </q-btn>
          </template>
          <q-btn
            v-if="activeTab === 'single'"
            color="primary"
            icon="save"
            label="저장"
            class="q-ml-sm"
            :loading="singleSaving"
            @click="saveSingle"
          />
          <q-btn
            v-else
            outline
            color="primary"
            icon="download"
            label="양식 다운로드"
            class="q-ml-sm"
            @click="downloadTemplate"
          />
        </Title>
      </div>
    </div>

    <div class="comp-box q-pa-md">
      <q-tabs
        v-model="activeTab"
        align="left"
        active-color="primary"
        indicator-color="primary"
        dense
      >
        <q-tab name="single" label="단건 등록" />
        <q-tab name="excel" label="엑셀 등록" />
      </q-tabs>

      <q-separator class="q-my-md" />

      <q-tab-panels v-model="activeTab" animated>
        <q-tab-panel name="single" class="q-pa-none">
          <div class="row items-start justify-between q-col-gutter-md q-mb-md">
            <div class="col">
              <div class="text-body2">관리자가 신규 상품을 한 건씩 직접 생성합니다.</div>
            </div>
          </div>

          <div class="q-mb-md">
            <q-banner class="bg-grey-2 text-grey-9">
              동일 SKU는 브랜드, 카테고리, HS CODE, 규격 타입, 규격값이 모두 같은 경우입니다.
              상품명만 같아서는 동일 SKU로 판단하지 않습니다.
              바코드 입력 후 포커스를 벗어나면 AONE 마스터 SKU가 자동 생성되며, 필요하면 직접 수정할 수 있습니다.
            </q-banner>
          </div>

          <div class="sku-form-sections">
            <section class="sku-form-section">
              <div class="sku-form-section__header sku-form-section__header--split">
                <div>
                  <div class="sku-form-section__title">식별 정보</div>
                  <div class="sku-form-section__caption">상품을 구분하고 바코드 기준으로 마스터 SKU를 관리합니다.</div>
                </div>
                <q-toggle v-model="singleForm.is_active" label="활성" color="green" />
              </div>
              <div class="row q-col-gutter-md">
                <div class="col-12 col-md-6">
                  <q-input v-model="singleForm.display_name" label="상품명" dense outlined />
                </div>
                <div class="col-12 col-md-3">
                  <q-input
                    v-model="singleForm.barcode"
                    label="바코드번호"
                    dense
                    outlined
                    maxlength="64"
                    inputmode="numeric"
                    @update:model-value="sanitizeBarcode"
                    @blur="generateMasterSkuCodeFromBarcode"
                  />
                </div>
                <div class="col-12 col-md-3">
                  <q-input
                    v-model="singleForm.master_sku_code"
                    label="마스터 SKU"
                    dense
                    outlined
                    maxlength="32"
                  />
                </div>
              </div>
            </section>

            <section class="sku-form-section">
              <div class="sku-form-section__header">
                <div class="sku-form-section__title">분류 정보</div>
                <div class="sku-form-section__caption">동일 SKU 판단에 사용하는 브랜드, 카테고리, HS CODE, 규격 타입입니다.</div>
              </div>
              <div class="row q-col-gutter-md">
                <div class="col-12 col-md-4">
                  <q-select
                    v-model="singleForm.brand_id"
                    :options="brands"
                    option-label="name"
                    option-value="brand_id"
                    emit-value
                    map-options
                    label="브랜드"
                    dense
                    outlined
                    :loading="masterDataLoading"
                  />
                </div>
                <div class="col-12 col-md-4">
                  <q-select
                    v-model="singleForm.category_id"
                    :options="categories"
                    option-label="name"
                    option-value="category_id"
                    emit-value
                    map-options
                    label="카테고리"
                    dense
                    outlined
                    :loading="masterDataLoading"
                  />
                </div>
                <div class="col-12 col-md-4">
                  <q-input v-model="singleForm.hs_code" label="HS CODE" dense outlined />
                </div>
              </div>
            </section>

            <section class="sku-form-section">
              <div class="sku-form-section__header">
                <div class="sku-form-section__title">물류 기본값</div>
                <div class="sku-form-section__caption">중량, 부피, 기본 치수처럼 포장과 운영에 쓰는 값입니다.</div>
              </div>
              <div class="row q-col-gutter-md items-center">
                <div class="col-12 col-md-2">
                  <q-input v-model="singleForm.weight_kg" label="중량 (kg)" dense outlined />
                </div>
                <div class="col-12 col-md-2">
                  <q-input v-model="singleForm.volume_cbm" label="부피 (cbm)" dense outlined />
                </div>
                <div class="col-12 col-md-2">
                  <q-input v-model="singleForm.length_cm" label="가로 (cm)" dense outlined />
                </div>
                <div class="col-12 col-md-2">
                  <q-input v-model="singleForm.width_cm" label="세로 (cm)" dense outlined />
                </div>
                <div class="col-12 col-md-2">
                  <q-input v-model="singleForm.height_cm" label="높이 (cm)" dense outlined />
                </div>
              </div>
            </section>

            <section class="sku-form-section">
              <div class="sku-form-section__header">
                <div class="sku-form-section__title">규격 상세</div>
                <div class="sku-form-section__caption">상품 옵션, 의류 사이즈, 포장 입수량처럼 동일 SKU를 나누는 값입니다.</div>
              </div>
              <div class="row q-col-gutter-md">
                <div class="col-12 col-md-4">
                  <q-select
                    v-model="singleForm.spec_type"
                    :options="specTypeOptions"
                    emit-value
                    map-options
                    label="규격 타입"
                    dense
                    outlined
                  />
                </div>
                <div class="col-12">
                  <SpecTypeForm :spec-type="singleForm.spec_type" v-model="singleForm.spec_detail" />
                </div>
              </div>
            </section>

            <section class="sku-form-section">
              <div class="sku-form-section__header">
                <div class="sku-form-section__title">파트너 연결 정보</div>
                <div class="sku-form-section__caption">
                  특정 파트너가 사용하는 SKU가 있으면 신규 상품 등록과 동시에 연결합니다. 입력하지 않아도 상품은 등록됩니다.
                </div>
              </div>
              <div class="row q-col-gutter-md">
                <div class="col-12 col-md-6">
                  <q-select
                    v-model="singleForm.partner_id"
                    :options="partnerOptions"
                    emit-value
                    map-options
                    label="파트너"
                    dense
                    outlined
                    clearable
                  />
                </div>
                <div class="col-12 col-md-6">
                  <q-input
                    v-model="singleForm.partner_sku_code"
                    label="파트너 SKU"
                    dense
                    outlined
                  />
                </div>
              </div>
            </section>
          </div>
        </q-tab-panel>

        <q-tab-panel name="excel" class="q-pa-none">
          <div class="excel-intro q-mb-md">
            <div>
              <div class="text-subtitle1">엑셀로 여러 상품 등록</div>
              <div class="text-caption text-grey-7 q-mt-xs">
                파일을 첨부하고 미리보기 결과를 수정한 뒤, 재검증을 통과한 데이터만 저장합니다.
              </div>
            </div>
            <div class="row q-gutter-sm items-center">
              <q-chip dense color="blue-1" text-color="primary" icon="info">
                xls, xlsx 지원
              </q-chip>
            </div>
          </div>

          <div class="excel-workflow q-pa-md q-mb-md">
            <input
              ref="importFileInput"
              type="file"
              accept=".xls,.xlsx"
              style="display: none;"
              @change="onNativeFileChange"
            >

            <div class="row q-col-gutter-lg items-stretch">
              <div class="col-12 col-lg-5">
                <div class="workflow-block">
                  <div class="workflow-label">
                    <span class="workflow-number">1</span>
                    파일 첨부
                  </div>
                  <div :class="['excel-upload-box', { 'excel-upload-box--selected': file }]">
                    <div class="row items-center no-wrap">
                      <q-icon
                        :name="file ? 'description' : 'upload_file'"
                        :color="file ? 'primary' : 'grey-6'"
                        size="28px"
                        class="q-mr-sm"
                      />
                      <div class="ellipsis">
                        <div class="text-body2 ellipsis">
                          {{ file ? file.name : '첨부된 파일이 없습니다.' }}
                        </div>
                        <div class="text-caption text-grey-7">
                          {{ file ? '미리보기를 실행해 내용을 확인하세요.' : '양식에 맞게 작성한 엑셀 파일을 선택하세요.' }}
                        </div>
                      </div>
                    </div>
                    <div class="row q-gutter-xs justify-end no-wrap">
                      <q-btn
                        outline
                        dense
                        color="primary"
                        icon="attach_file"
                        label="파일 선택"
                        @click="triggerFilePicker"
                      />
                      <q-btn
                        v-if="file"
                        flat
                        round
                        dense
                        color="grey-7"
                        icon="close"
                        aria-label="선택 해제"
                        @click="clearSelectedFile"
                      >
                        <q-tooltip>선택 해제</q-tooltip>
                      </q-btn>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-7">
                <div class="workflow-block">
                  <div class="workflow-label">
                    <span class="workflow-number">2</span>
                    검토 및 저장
                  </div>
                  <div class="text-caption text-grey-7 q-mb-md">
                    파일 첨부 후 미리보기, 재검증, 저장 순서로 진행합니다.
                  </div>
                  <div class="row q-gutter-sm items-center excel-action-row">
                    <q-btn color="primary" icon="preview" label="미리보기" :disable="!file" :loading="importLoading" @click="previewImport" />
                    <q-btn outline color="secondary" icon="fact_check" label="재검증" :disable="!hasImportRows" :loading="importLoading" @click="revalidateImportRows" />
                    <q-btn color="positive" icon="save" label="저장" :disable="!hasImportRows || hasImportErrors" :loading="importCommitting" @click="commitImport" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row q-col-gutter-md q-mb-md items-stretch">
            <div class="col-12 col-md-4">
              <div class="comp-box q-pa-md excel-summary-card">
                <div class="row items-center justify-between">
                  <div>
                    <div class="text-caption text-grey-7">전체 행</div>
                    <div class="text-h5 q-mt-xs">{{ importSummary.total }}</div>
                  </div>
                  <q-icon name="table_rows" color="grey-6" size="28px" />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="comp-box q-pa-md excel-summary-card excel-summary-card--valid">
                <div class="row items-center justify-between">
                  <div>
                    <div class="text-caption text-green-9">등록 가능</div>
                    <div class="text-h5 q-mt-xs text-green-10">{{ importSummary.valid }}</div>
                  </div>
                  <q-icon name="check_circle" color="green-7" size="28px" />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="comp-box q-pa-md excel-summary-card excel-summary-card--invalid">
                <div class="row items-center justify-between">
                  <div>
                    <div class="text-caption text-red-9">수정 필요</div>
                    <div class="text-h5 q-mt-xs text-red-10">{{ importSummary.invalid }}</div>
                  </div>
                  <q-icon name="error" color="red-7" size="28px" />
                </div>
              </div>
            </div>
          </div>

          <div class="import-review">
            <div class="row items-center justify-between q-mb-md">
              <div>
                <div class="text-subtitle1">업로드 데이터 검토</div>
                <div class="text-caption text-grey-7 q-mt-xs">
                  셀을 직접 수정할 수 있습니다. 수정 후에는 재검증을 실행하세요.
                </div>
              </div>
              <q-chip v-if="hasImportRows" dense outline color="primary">
                {{ importSummary.total }}개 행
              </q-chip>
            </div>

            <div v-if="hasImportRows" class="import-grid">
              <q-markup-table flat bordered separator="cell">
              <thead>
                <tr>
                  <th class="text-center">행</th>
                  <th>상품명</th>
                  <th>바코드</th>
                  <th>브랜드</th>
                  <th>카테고리</th>
                  <th>HS CODE</th>
                  <th>규격 타입</th>
                  <th>규격 상세</th>
                  <th>중량</th>
                  <th>부피</th>
                  <th>가로</th>
                  <th>세로</th>
                  <th>높이</th>
                  <th>활성</th>
                  <th>오류</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in importRows" :key="`${row.row_no}-${index}`">
                  <td class="text-center">{{ row.row_no }}</td>
                  <td><q-input v-model="row.display_name" dense outlined /></td>
                  <td><q-input v-model="row.barcode" dense outlined /></td>
                  <td>
                    <q-select
                      v-model="row.brand_id"
                      :options="brands"
                      option-label="name"
                      option-value="brand_id"
                      emit-value
                      map-options
                      dense
                      outlined
                    />
                  </td>
                  <td>
                    <q-select
                      v-model="row.category_id"
                      :options="categories"
                      option-label="name"
                      option-value="category_id"
                      emit-value
                      map-options
                      dense
                      outlined
                    />
                  </td>
                  <td><q-input v-model="row.hs_code" dense outlined /></td>
                  <td>
                    <q-select
                      v-model="row.spec_type"
                      :options="specTypeOptions"
                      emit-value
                      map-options
                      dense
                      outlined
                    />
                  </td>
                  <td style="min-width: 280px;">
                    <SpecTypeForm :spec-type="row.spec_type" v-model="row.spec_detail" />
                  </td>
                  <td><q-input v-model="row.weight_kg" dense outlined /></td>
                  <td><q-input v-model="row.volume_cbm" dense outlined /></td>
                  <td><q-input v-model="row.length_cm" dense outlined /></td>
                  <td><q-input v-model="row.width_cm" dense outlined /></td>
                  <td><q-input v-model="row.height_cm" dense outlined /></td>
                  <td class="text-center">
                    <q-toggle v-model="row.is_active" color="green" />
                  </td>
                  <td class="text-left text-negative">
                    <div v-if="row.errors && row.errors.length">
                      <div v-for="(error, errorIndex) in row.errors" :key="errorIndex">{{ error }}</div>
                    </div>
                    <div v-else class="text-green-8">정상</div>
                  </td>
                  <td class="text-center">
                    <q-btn flat dense color="negative" icon="delete" @click="removeImportRow(index)" />
                  </td>
                </tr>
              </tbody>
              </q-markup-table>
            </div>

            <div v-else class="excel-empty-state">
              <q-icon name="table_view" color="grey-5" size="42px" />
              <div class="text-body2 text-grey-8 q-mt-sm">아직 미리보기 데이터가 없습니다.</div>
              <div class="text-caption text-grey-6 q-mt-xs">엑셀 파일을 첨부하고 미리보기를 실행하세요.</div>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>

    <PageGuideDialog
      v-model="guideDialog"
      title="신규 등록 사용 가이드"
      description="단건 등록과 엑셀 등록 절차를 확인할 수 있습니다."
    >
      <MasterSkuRegisterGuide />
    </PageGuideDialog>
  </q-page>
</template>

<style scoped>
.full-height {
  height: 100%;
}

.sku-form-sections {
  border: 1px solid #dfe5ec;
  border-radius: 10px;
  background: #fff;
}

.sku-form-section {
  padding: 18px;
}

.sku-form-section + .sku-form-section {
  border-top: 1px solid #e7ecf2;
}

.sku-form-section__header {
  margin-bottom: 14px;
}

.sku-form-section__header--split {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.sku-form-section__title {
  color: #263238;
  font-size: 15px;
  font-weight: 700;
}

.sku-form-section__caption {
  margin-top: 3px;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.45;
}

.excel-intro {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.excel-workflow,
.import-review {
  border: 1px solid #dfe5ec;
  border-radius: 12px;
  background: #f8fafc;
}

.workflow-block {
  height: 100%;
}

.workflow-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.workflow-number {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: #1976d2;
  font-size: 12px;
}

.excel-upload-box {
  min-height: 88px;
  border: 1px dashed #b8c2cf;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #fff;
}

.excel-upload-box--selected {
  border-color: #1976d2;
  background: #f3f8ff;
}

.excel-action-row {
  flex-wrap: wrap;
}

.excel-summary-card {
  min-height: 88px;
}

.excel-summary-card--valid {
  background: #edf9f0;
}

.excel-summary-card--invalid {
  background: #fff1f1;
}

.import-review {
  padding: 16px;
  background: #fff;
}

.excel-empty-state {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d3dae4;
  border-radius: 10px;
  background: #fafbfc;
  text-align: center;
}

</style>

<style scoped lang="scss">
.import-grid {
  overflow-x: auto;
}
</style>
